import type { z } from 'zod';

import { booleanMutationSchema, nullableNumericMutationSchema } from '@/_schemas/generic';

import { inventoryVolumeQuerySchema } from './inventory-volumes-query-schema';

export const inventoryVolumeUpdateSchema = inventoryVolumeQuerySchema.extend({
  quantity: nullableNumericMutationSchema(),
  primary: booleanMutationSchema(),
});

export type InventoryVolumeUpdateSchema = z.infer<typeof inventoryVolumeUpdateSchema>;

export const inventoryVolumeCreateSchema = inventoryVolumeUpdateSchema.omit({
  id: true,
});

export type InventoryVolumeCreateSchema = z.infer<typeof inventoryVolumeCreateSchema>;
